import { FileManagerFile } from "../service/FileManager/FileManagerFile";

export interface OnClickAction {
    type: OnClickActionType;
    value: any;
    isAdultLink?: boolean;
}

export interface OnClickActionFile extends OnClickAction {
    fileObject: FileManagerFile;
    base64Vcard?: string;
}

export enum OnClickActionType {
    None= 6,
    OpenLink = 0,
    Page = 1,
    WriteEmail = 2,
    CallPhone = 3,
    OpenFile = 4,
    SaveVcard = 5,
    OpenPage = 7,
    OpenPopup = 8,
    ScrollTo = 9
}